var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.043 0H6.04297C4.94297 0 4.04297 0.9 4.04297 2V14C4.04297 15.1 4.94297 16 6.04297 16H18.043C19.143 16 20.043 15.1 20.043 14V2C20.043 0.9 19.143 0 18.043 0ZM9.54297 7.5C9.54297 8.33 8.87297 9 8.04297 9H7.04297V10.25C7.04297 10.66 6.70297 11 6.29297 11C5.88297 11 5.54297 10.66 5.54297 10.25V6C5.54297 5.45 5.99297 5 6.54297 5H8.04297C8.87297 5 9.54297 5.67 9.54297 6.5V7.5ZM14.543 9.5C14.543 10.33 13.873 11 13.043 11H11.043C10.763 11 10.543 10.78 10.543 10.5V5.5C10.543 5.22 10.763 5 11.043 5H13.043C13.873 5 14.543 5.67 14.543 6.5V9.5ZM18.543 5.75C18.543 6.16 18.203 6.5 17.793 6.5H17.043V7.5H17.793C18.203 7.5 18.543 7.84 18.543 8.25C18.543 8.66 18.203 9 17.793 9H17.043V10.25C17.043 10.66 16.703 11 16.293 11C15.883 11 15.543 10.66 15.543 10.25V6C15.543 5.45 15.993 5 16.543 5H17.793C18.203 5 18.543 5.34 18.543 5.75ZM7.04297 7.5H8.04297V6.5H7.04297V7.5ZM1.04297 4C0.492969 4 0.0429688 4.45 0.0429688 5V18C0.0429688 19.1 0.942969 20 2.04297 20H15.043C15.593 20 16.043 19.55 16.043 19C16.043 18.45 15.593 18 15.043 18H3.04297C2.49297 18 2.04297 17.55 2.04297 17V5C2.04297 4.45 1.59297 4 1.04297 4ZM12.043 9.5H13.043V6.5H12.043V9.5Z",
    fill: "#EF5C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon_file.15b73764f326314654c563a8d1b72303.svg";
export { ForwardRef as ReactComponent };